import React from "react";
import MainLayout from "../../components/MainLayout/MainLayout";
import Head from "next/head";
const Terms = () => {
  return (
    <>
      <Head>
        <title>ShotQuality | Terms of Service</title>
      </Head>
      <MainLayout>
        <main id="ContentBox">
          <div className="Aboutlist sticky">
            <div className="container">
              <h2>Terms of Service</h2>
            </div>
          </div>
          <div className="Statside">
            <div className="container">
              <p>
                In the following “Terms of Use”, the term "shotqualitybets.com" or "us" or "we" or "Web Site" refers to
                the owner of the Web Site, ShotQ LLC. The term "You" refers to the user or viewer of the Web Site.
              </p>
              <p>
                These "Terms of Use" set forth the terms and conditions that apply to your use of shotqualitybets.com
                (the "Web Site"). By using the Web Site (other than to read this page for the first time), You agree to
                comply with all of the Terms of Use set forth herein. The right to use the Web Site is personal to you
                and is not transferable to any other person or entity.
              </p>
              <h2>Copyrights and Trademarks</h2>
              <ul>
                <li>A. All materials contained on the Web Site are owned by ShotQ LLC. All rights reserved.</li>
                <li>
                  B. All intellectual property rights are owned by ShotQ LLC. This includes design elements unique to
                  the Web Site.
                </li>
                <li>
                  C. You may use information from the Web Site under typical "Fair use" standards provided
                  shotqualitybets.com is cited as the source. Using information from the Web Site to support your work
                  that is entirely acceptable and encouraged. However, copying large portions of content available to
                  subscribers is prohibited.
                </li>
                <li>
                  D. The Web Site and other trademarks and/or service marks (including logos and designs) found on the
                  Web Site are trademarks/service marks that identify shotqualitybets.com and the goods and/or services
                  provided by the Web Site. Such marks may not be used under any circumstances without the prior written
                  authorization of the Web Site.{" "}
                </li>
                <li>
                  E. You may not modify, publish, transmit, participate in the transfer or sale, create derivative
                  works, or in any way exploit any of the content of this site, in whole or in part.
                </li>
                <li>
                  F. This website is protected from content theft by both passive and active components. Any copyright
                  infringements of the website content and other copyrighted material will result in prosecution
                  according to the international copyright law, the Digital Millennium Copyright Act (DCMA), and any
                  other applicable law or regulation.
                </li>
                <li>
                  G. Any redistribution or reproduction of part or all of the contents in any form is prohibited other
                  than the following:
                </li>
                <li>
                  H. You may not, except with our express written permission, distribute or commercially exploit the
                  content. Nor may you transmit it or store it in any other website or other form of electronic
                  retrieval system.
                </li>
              </ul>
              <h2>Contributions to the Web Site</h2>
              <p>
                If you are invited to submit any contribution to the Web Site (including any text, photographs,
                graphics, video or audio) You agree, by submitting your contribution, to grant the Web Site a perpetual,
                royalty-free, non-exclusive, sub-licensable right and license to use, reproduce, modify, adapt, publish,
                translate, create derivative works from, distribute, perform, play, make available to the public, and
                exercise all copyright and publicity rights with respect to Your contribution worldwide and/or to
                incorporate your contribution in other works in any media now known or later developed for the full term
                of any rights that may exist in your contribution.
              </p>
              <h2>Links to Third-Party Web Sites</h2>
              <p>
                The Web Site may provide hyperlinks to third-party web sites as a convenience to users of the Web Site.
                The Web Site does not control third-party web sites and is not responsible for the contents of any
                linked-to, third-party web sites or any hyperlink in a linked-to website. The Web Site does not endorse,
                recommend or approve any third-party web site hyperlinked from the Web Site. The Web Site shall not be
                liable to You or any entity for the content or use of the content available through such a hyperlink.
              </p>
              <h2>Subpoenas</h2>
              <p>
                The Web Site may be required to disclose information to individuals asserting rights under the Digital
                Millennium Copyright Act. You hereby authorize the Web Site to release information about You if required
                by law or subpoena without notice to You.
              </p>
              <h2>Indemnification</h2>
              <p>
                You will indemnify the Web Site and its agents, affiliates, and employees from any liability, loss, or
                expense (including but not limited to reasonable attorneys' fees and costs) resulting from any
                third-party claim or proceeding in which it is alleged that any content posted by You or the use thereof
                infringes or violates the intellectual property rights, privacy rights, publicity rights, or moral
                rights of another or is unlawful.
              </p>
              <h2>Disclaimer of Warranties</h2>
              <p>
                Your use of this site provided by the Web Site is without warranty, and in an as-is condition and on an
                as available basis. The Web Site does not guarantee the accuracy or reliability of the information
                presented on this website.
              </p>
              <p>
                The Web Site does not represent nor warrant that the site or use (I) will be uninterrupted, (II) will be
                free of defects, inaccuracies or errors, (III) will meet your requirements, or (IV) will operate in the
                configuration or with other hardware or software You use. The Web Site makes no warranties other than
                those made expressly in these terms of use, and hereby disclaims any and all implied warranties,
                including without limitation, warranties of fitness for a particular purpose, merchantability and
                noninfringement.
              </p>
              <h2>Exclusion of Damages</h2>
              <p>
                The Web Site will not be liable to You or any third party for any consequential, incidental, indirect,
                punitive or special damages (including damages relating to lost profits, lost data or loss of goodwill)
                arising out of, relating to or connected with the use of the site, based on any cause of action, even if
                advised of the possibility of such damages.
              </p>
              <h2>Forum and choice of law</h2>
              <p>
                You agree that by visiting and using this site, to be governed by the Laws of the State of Utah. Any and
                all actions or claims between You and the Web Site shall be brought in a court of competent jurisdiction
                within the borders of Utah State, at the court closest to the Web Site headquarters or Simon Gerzsberg's
                then-current residence.
              </p>
              <h2>Force Majeure</h2>
              <p>
                The Web Site will not be liable for failing to perform under these terms of use by the occurrence of any
                event beyond its reasonable control, including, without limitation, a labor disturbance, an Internet
                outage or interruption of service, a communications outage, failure by a service provider to the Web
                Site to perform, fire, terrorism, natural disaster or war, or sheer laziness.
              </p>
              <h2>Additional Terms of Service for Subscribers</h2>
              <ul>
                <li>
                  All subscription fees are non-refundable. The Web Site reserves the right to make changes to its
                  content at any time. If the Web Site temporarily reduces or eliminates the charge for content or
                  access that You are currently paying for under different terms, You will not receive a refund.
                </li>
              </ul>
            </div>
          </div>
        </main>
      </MainLayout>
    </>
  );
};

export default Terms;
